import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { API_ORIGIN } from '../../config';

/**
 * Whether the signed-in staff member may manage client admin accounts (create dynamic forms,
 * reset client admin passwords). Same check the client admin sign-in modal used.
 */
const useCanManageClientAdmins = () => {
  const { user } = useAuth();
  const [canManage, setCanManage] = useState(false);

  useEffect(() => {
    if (!user) return;
    const checkPermissions = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setCanManage(false);
          return;
        }

        const response = await fetch(`${API_ORIGIN}/api/employee/can-manage-client-admins`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          setCanManage(data.canManageClientAdmins || false);
        } else {
          setCanManage(false);
        }
      } catch (error) {
        setCanManage(false);
      }
    };
    checkPermissions();
  }, [user]);

  return canManage;
};

export default useCanManageClientAdmins;
